import { Component, Input } from '@angular/core';

import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'button-spinner',
    templateUrl: './button-spinner.component.html',
    styleUrls: ['./button-spinner.component.scss'],
    standalone: false
})
export class ButtonSpinnerComponent extends SpinnerComponent {
  @Input() btnClasses: string[] = [];
}
